import { Routes } from '@angular/router';
import { blockWebVersionGuard, MyGamesRoutes } from '@core';
import { isAuthedGuard } from '@auth';
import { MyGamesComponent } from './components';
import { loadMyGamesResolver } from './application/resolvers';

export const MyGamesRouting: Routes = [
  {
    path: MyGamesRoutes.ROOT,
    component: MyGamesComponent,
    resolve: { loadMyGamesResolver },
    canActivate: [blockWebVersionGuard, isAuthedGuard]
  }
];
